import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Return = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M15.75 6.75H5.625C3.76104 6.75 2.25 8.26104 2.25 10.125C2.25 11.989 3.76104 13.5 5.625 13.5H9M15.75 6.75L12.75 3.75M15.75 6.75L12.75 9.75"
        stroke="#24B07E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'transparent'}
      />
    </SvgIcon>
  );
};

export default Return;
